import l from "@loadable/component";

const content = l(() => import("containers/Reactivate"));

export default {
  key: "reactivate",
  title: "Reactivate",
  path: "/reactivate",
  exact: true,
  linkTarget: "/reactivate",
  basePath: "reactivate",
  requiredParams: [],
  optionalParams: [],
  content,
  sidebar: null,
};
